import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_MESSAGES, wa, track } from "../../data/site";

export const WhatsAppFab = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={wa(WA_MESSAGES.default)}
          target="_blank"
          rel="noopener noreferrer"
          id="cta-fab"
          data-testid="cta-fab-whatsapp"
          data-event="whatsapp_click"
          onClick={() => track("whatsapp_click", { location: "fab" })}
          aria-label="Falar no WhatsApp"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="cta-whatsapp fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-whatsapp text-white shadow-2xl shadow-whatsapp/40 transition-transform duration-300 hover:scale-110"
        >
          <span className="absolute inset-0 rounded-full bg-whatsapp animate-pulse-ring" aria-hidden="true" />
          <MessageCircle className="relative h-6 w-6" />
        </motion.a>
      )}
    </AnimatePresence>
  );
};
